<template>
<div class="grid">



<div class="col-12" v-if="report">





<DataTable 
:value="report.groups" 
:lazy="true" 
:paginator="false" 
class="p-datatable-suppliers" 
:rows="rows"
:page="page+1"
:first="first"
:totalRecords="totalRecords"
dataKey="id" 
:rowHover="true" 
v-model:filters="filters" 
filterDisplay="menu" 
:loading="loading"
@page="onPage($event)" 
@sort="onSort($event)" 
@filter="onFilter($event)"
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport" 
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:globalFilterFields="globalfilterfields" 
responsiveLayout="scroll"
>

<template #header>
<div class="grid">
<div class="col-12 ">
<div style="text-align:left">
 <!-- <MultiSelect :modelValue="selectedcolumns" :options="columns" optionLabel="header" @update:modelValue="onToggle"    
      display="chip" placeholder="Select Columns" />-->
</div>
</div>
</div>
</template>


<template #empty>
No report data found.
</template>

<template #loading>
<div class="loading_overlay">
<ProgressSpinner style="width:50px;height:50px" strokeWidth="4" color="deneme" />
Loading report data. Please wait.
</div>
</template>




<Column field="name" header="#"  style="min-width: 15rem;max-width:20rem">
<template #body="{data}">
<p>{{data.name}}</p>
</template>

</Column>



<!-- columns -->
<template v-for="(column,index) in selectedcolumns" :key="column.id">

<Column :header="getTitleTranslation(column.id)"  
style="min-width: 14rem" 
:sortable="column.sortable" 
:filterMenuStyle="{'width':'14rem'}"
:showFilterMenu="column.filterable"
:field="column.id.toString()"
:showFilterMatchModes="false"
>



<template #filter="{filterModel,filterCallback}" v-if="column.filteroptions">

  <template v-if="column.filteroptions.type=='questionlist_points' || column.filteroptions.type=='questionlist_nonconformity_count' || column.filteroptions.type=='section_points' || column.filteroptions.type=='inputfield_point'">
    <Slider v-model="filterModel.value" range class="m-3"></Slider>
            <div class="flex align-items-center justify-content-between px-2">
                <span>{{ filterModel.value ? filterModel.value[0] : 0 }}</span>
                <span>{{ filterModel.value ? filterModel.value[1] : column.filteroptions.id }}</span>
            </div>
  </template>

  <template v-if="column.filteroptions.type=='inputfield_submission' || column.filteroptions.type=='custom_attribute' || column.filteroptions.type=='project_status' || column.filteroptions.type=='flow_status'">
      <Dropdown v-model="filterModel.value" :options="column.filterselectors" placeholder="Hepsi" class="p-column-filter" :showClear="true">
        <template #value="slotProps">
            <span :class="'customer-badge status-' + slotProps.value" v-if="slotProps.value">{{slotProps.value.name}}</span>
            <span v-else>{{slotProps.placeholder}}</span>
        </template>
        <template #option="slotProps">
            <span :class="'customer-badge status-' + slotProps.option">{{slotProps.option.name}}</span>
        </template>
    </Dropdown>
  </template>
    
</template>




<template #body="slotProps">
{{getCellValue(slotProps.data.id,column.id)}}
</template>

</Column>


</template>
<!-- columns -->







</DataTable>


</div>
</div>
</template>

<script>
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import AnalyticsListOutputCell from "./AnalyticsListOutputCell"
import AnalyticsGroupOutputCell from "./AnalyticsGroupOutputCell"

let boolean_statuses = [
          {name:"Hepsi",id:"all"},
          {name:"Açık",id:1},
          {name:"Kapalı",id:0},
        ]

export default {
  name: 'AnalyticsGroupOutput',

  data () {
    return {
      loading:true,
      report:null,
      columns:[],
      selectedcolumns:[],
      custom_attributes:[],
      custom_attribute:null,
      listitems:[],
      rows:10,
      page:0,
      first:0,
      sort_column:"",
      sort_order:1,
      totalRecords:0,
      selectedSuppliers:[],
      globalfilterfields:['name','suppliercode'],
      hidden_columns:[],
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'suppliercode': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
      },
    }
  },
  components:{AnalyticsListOutputCell,AnalyticsGroupOutputCell},
  computed:
  {
    statuses()
    {
        let arr = [
        {name:"Hepsi",id:"all"},
        {name:this.$store.state.languages.lang_phrases.olusturuldu,id:"created"},
        {name:this.$store.state.languages.lang_phrases.goruntulendi,id:"viewed"},
        {name:this.$store.state.languages.lang_phrases.baslandi,id:"started"},
        {name:this.$store.state.languages.lang_phrases.tamamlandi0,id:"finished"},
        {name:this.$store.state.languages.lang_phrases.degerlendirmede,id:"under_review"},
        {name:this.$store.state.languages.lang_phrases.iptal_edildi,id:"canceled"},
        {name:this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede,id:"correction_requested"},
        ]
        return  arr
    },
    cellclass()
    {
      if(this.report.columns.length>5)
      {
        return "customtable_cell"
      }
      else
      {
        return "customtable_cell_wide"
      }
    },
    visibleColumns()
    {

    },
  },
  async mounted()
  {
    this.report = await this.generalApiGetWithoutLoader("brand_report_columns/"+this.$route.params.report_id)
    console.log("REPORT")
    console.log(this.report)
    let columns = this.report.columns
    //this.custom_attribute = this.report.groups[0].customattribute
    
    for(let column of columns)
    {
      let filter_obj
      let filteroptions = JSON.parse(column.filteroptions)
      column.filteroptions = filteroptions

      if(filteroptions)
      {
          if(filteroptions.type=="project_status" || filteroptions.type=="flow_status")
          {
            filter_obj = {value: null, matchMode: FilterMatchMode.EQUALS}
            column.filterselectors = this.sanitizeArray([{name:"Hepsi",id:"all"},
            {name:this.$store.state.languages.lang_phrases.olusturuldu,id:"created"},
            {name:this.$store.state.languages.lang_phrases.goruntulendi,id:"viewed"},
            {name:this.$store.state.languages.lang_phrases.baslandi,id:"started"},
            {name:this.$store.state.languages.lang_phrases.tamamlandi0,id:"finished"},
            {name:this.$store.state.languages.lang_phrases.degerlendirmede,id:"under_review"},
            {name:this.$store.state.languages.lang_phrases.iptal_edildi,id:"canceled"},
            {name:this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede,id:"correction_requested"},])
            this.filters[column.id.toString()] = filter_obj
            this.globalfilterfields.push(column.id.toString())
          }

           if(filteroptions.type=="custom_attribute" )
          {
            filter_obj = {value: null, matchMode: FilterMatchMode.EQUALS}
            if(filteroptions.item_type=="select")
            {
              let custom_attribute_options = await this.generalApiGetWithoutLoader("custom_attributes/options/"+filteroptions.id)
              column.filterselectors = custom_attribute_options
            }
            if(filteroptions.item_type=="boolean")
            {
              column.filterselectors = this.sanitizeArray(boolean_statuses)
            }
            this.filters[column.id.toString()] = filter_obj
            this.globalfilterfields.push(column.id.toString())
            
          }

          if(filteroptions.type=="questionlist_points" ||filteroptions.type=="questionlist_nonconformity_count"||filteroptions.type=="section_points" || filteroptions.type=="inputfield_point" )
          {
            filter_obj = { value: [0, filteroptions.id], matchMode: FilterMatchMode.BETWEEN }
            this.filters[column.id.toString()] = filter_obj
          this.globalfilterfields.push(column.id.toString())
          }
      }

      

     
      
      
      

      
      if(column.sortable===1)
      {
        column.sortable = true
      }
      else
      {
        column.sortable = false
      }

      if(column.filterable===1)
      {
        column.filterable = true
      }
      else
      {
        column.filterable = false
      }
    }
    this.columns = columns
    this.selectedcolumns = columns
    await this.resolveGroupData()
  	await this.getData()
  },
  methods:{
    onToggle(value)
    {
      //console.log(value)        
      let result = this.selectedcolumns.filter(o1 => !this.columns.some(o2 => o1.id === o2.id));
      this.selectedcolumns = result
    },
    async resolveGroupData()
    {
      let theschema = JSON.parse(this.report.theschema)
      let input_node = theschema.nodes.find(item=> item.key =="sources" && item.type=="suppliers")
      let output_node = theschema.nodes.find(item=> item.key =="outputs" && item.type=="group")
      if(output_node)
      {
        for(let column of this.columns)
        {
          let column_stack_equ = input_node.data.outputs.find(item=> item.stack_id == column.input_stack_id)
          if(column_stack_equ && column_stack_equ.type=="custom_attribute")
          {

          }
        }
      }

      

    },
    getCellValue(group_id,column_id)
    {
    	console.log("getCellValue")
      console.log(group_id)
      console.log(column_id)
    	
    	let group = this.report.groups.find((item)=>{return item.id == group_id})
      let column = this.report.columns.find((item)=>{return item.id == column_id})
      console.log("column")
      console.log(column)
      console.log(group)
      let total = 0
      let count = 0
      let avegareg = 0
      

      if(group.json_data)
      {
        let json_data = JSON.parse(group.json_data)
        json_data = json_data.filter((item)=>{return item.column_id == column_id})
        if(json_data.length)
        {
          let method = column.grouping_method
          console.log(json_data)
          let data = []
          for(let item of this.listitems)
          {
            let the_element = item.output.find((element)=>{return element.column_id == column_id})
            if(the_element)
            {
              if(the_element.value || the_element.value===0)
              {
                data.push(the_element)
              }
              
            }

          }

          if(column.grouping_method=="supplier_toplam")
          {
            console.log("supplier_toplam")
            console.log(data)
            return data.length
          }
          else
          {
            for(let item of data)
            {
              total +=item.value
            }
            if(column.grouping_method=="deger_toplam")
            {
              return total
            }
            if(column.grouping_method=="ortalama")
            {
              return total/data.length
            }
          }
          
          
         

          //return data.value
        }
      }

      return null

      

    	
    	
      
    },
    sortByColumn(column)
    {
      console.log(column)
      console.log(this.report.listitems[0])
      let column_index = this.report.listitems[0].output.findIndex((item)=>{return item.column_id == column.id})
      this.report.listitems = this.sortByColumn(column_index)
    },
    columnSort(column_index)
    {
      let arr = this.report.listitems.sort((a, b) => a.output[column_index].value - b.output[column_index].value)
      return arr
    },
    async getData()
    {
        

      this.loading  = true
      this.custom_attributes =  await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
      let data = await this.generalApiGetWithoutLoader("brand_all_report_data_for_group/"+this.$route.params.report_id)
      console.log(data)
      
      
      this.listitems =  await data

      
      this.loading  = false
    },
    getTitleTranslation(id)
    {
      let column = this.columns.find((item)=>{return item.id == id})
      let translation = column.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
      if(translation)
      {
        return translation.translation
      }
      else
      {
        return column.name
      }
    },
    onPage(event)
    {
        console.log("onPage")
        console.log(event)
        this.page = event.page
        this.getData()
        
    },
    onSort(event)
    {        
        console.log("onSort")
        console.log(event)
        //return false
        this.sort_column = event.sortField
        this.sort_order = event.sortOrder
        this.getData()
    },
    onFilter(event)
    {
        //console.log("filter")
        this.page = 0
        console.log("onFilter")
        console.log(event)
    },
  }
}
</script>

<style lang="scss" scoped>
.loading_overlay
{
    background-color:rgba(53, 47, 141, 0.5);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-suppliers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>